// global.$ = global.jQuery = require('jquery');
import { createApp } from 'vue'
import { VueCookies } from 'vue-cookies';
import mitt from 'mitt'
import DetailsViewView from '@vueapp/views/DetailsView.vue'

import VueTippy from 'vue-tippy'
import naive from 'naive-ui';

export class DetailsView {

	constructor( elements ) {
        let _this = this

        if ( elements.length ) {
            elements.forEach(function (item, key) {
            	const emitter = mitt()
				const app = createApp(DetailsViewView, {
					postId: item.getAttribute('data-post-id'),
					postSlug: item.getAttribute('data-post-slug')
				})
				app.config.globalProperties.emitter = emitter
				app.mount('#' + item.getAttribute('id') )    
				app.use(
					VueTippy,
						// optional
						{
							directive: 'tippy', // => v-tippy
							component: 'tippy', // => <tippy/>
							componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,

							defaultProps: {
							  	// placement: 'auto-end',
							  	allowHTML: true,
							  	theme: 'bryter',
							    placement: 'right',
							}, // => Global default options * see all props
						}
			  	)
		  		app.use( naive )
		  		app.use( VueCookies )
            })
        }

	}
	

}